<div class="container">
    <div class="title-podcast">Agenda Prospectiva</div>
    <div class="principal-summary">
        <!-- {{podcastGroupDesc}} -->
        <ng-container *ngIf="t1?.summary">{{t1.summary}}</ng-container>
    </div>
    <br>
    <app-carousel-pubs [data]="dataCarousel" [color]="'#3b69ae'"></app-carousel-pubs>
    <br>
    <div class="buscador">
        <!-- Buscador -->
        <input id="searchInput" type="text" placeholder="Buscar podcasts..." #searchInputRef autocomplete="off">
        <button class="search-button" (click)="performSearch(searchInputRef.value)">
            <i class="fa fa-search" style="color: aliceblue;"></i>
        </button>
    </div>
    <div *ngIf="!resultsEnct && filteredPodcasts.length > 0" class="resultados-encontrados">
        Resultados encontrados
        <br>
        <br>
    </div>
    <div class="row">
        <div class="col-sm-8 col-md-9">
            <ng-container *ngIf="resultsEnct">
                <div class="col-sm-4 no-results-message" style="text-align: center;">
                    No se encontraron resultados
                </div>
            </ng-container>
            <ng-container *ngIf="!resultsEnct">
                <div *ngFor="let podcast of getPaginatedPodcasts(); let i = index;">
                    <div>
                        <h3 class="fw-bold">EP.{{ podcast.episode }} | {{ podcast.name }} </h3>
                    </div>
                    <div [attr.id]="'reproductor-container' + i" class="iframe"></div>
                    <div class="date-ficha d-flex justify-content-between">
              <small *ngIf="podcast?.publicationDate">Fecha publicación: {{ podcast?.publicationDate | date: 'd MMMM yyyy' }}</small>
              <small *ngIf="podcast?.lastUpdated">Fecha actualización: {{ podcast?.lastUpdated | date: 'd MMMM yyyy' }}</small>
            </div>   
            <div class="pb-2">
                        <span>Escuchar en </span>
                        <a class="underline" [href]="podcast.urlSpotify" target="_blank">Spotify</a> |
                        <span>Ver en </span>
                        <a class="underline" [href]="podcast.urlYoutube" target="_blank">Youtube</a> | compartir en:
                        <a href="#" target="_blank" class="social-icon" (click)="shareOnFacebook(podcast.urlSpotify)">
                            <i class="fa fa-facebook"></i>
                        </a>
                        <a href="#" target="_blank" class="social-icon" (click)="shareOnTwitter(podcast.urlSpotify)">
                            <i class="fa fa-twitter"></i>
                        </a>
                    </div>
                    <div class="description-content" [hidden]="!showDescription[i]">
                        <h6 class="font-weight-bold pb-2">Descripción</h6>
                        <p class="text-justify">{{ podcast.description }}</p>
                    </div>
                    <a class="show-description-link" (click)="toggleDescription(i)">
                        {{ showDescription[i] ? 'Ver menos' : 'Ver más' }}
                    </a>
                </div>
            </ng-container>
            <br>
            <!-- Agregar controles de paginación -->
            <nav aria-label="Page navigation" *ngIf="showPaginator">
                <ul class="pagination">
                    <li class="page-item" *ngFor="let pageNumber of getPageNumbers()">
                        <a class="page-link" href="javascript:void(0);" [class.page-number]="true"
                            [class.active]="isPageActive(pageNumber)" (click)="changePage(pageNumber)">
                            {{ pageNumber }}
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-sm-4 col-md-3">
            <h4 class="fw-bold">Próximos episodios</h4>
            <ng-container *ngIf="nextEpisodes">
                <div class="card mb-3 cards-podcasts" *ngFor="let e of nextEpisodes">
                    <img class="card-img-top" src="{{URL}}{{e.img}}" alt="{{ e.longtitle }}">
                    <div class="card-body">
                        <p class="card-text"><b>Episodio</b><br><span class="card-subtext">{{ e.name }}</span></p>
                    </div>
                </div>
                <br>
            </ng-container>
        </div>
    </div>
    <br>
</div>